<script>

    import { mapGetters, mapState } from 'vuex';
    import deepCopy from 'deepcopy'

    export default {
        name: "PopupNotifications",       
        computed: {
            ...mapState([
                'subscriptionMode'
            ]),
            ...mapState('pages', [
                'isAfterLogin',
                'pageContext'
            ]),
            ...mapState('user', [
                'trialExpiredFlag',
                'pendingInvoicesFlag',
                'onTrial'
            ]),
            ...mapGetters('user',[
                'isAdmin'
            ]),          
        },
        mounted(){
            this.handleAlerts(this.pageContext);
        },
        methods:{
            showTrialExpiredNotification(){
                if(this.trialExpiredFlag && this.subscriptionMode && this.isAfterLogin){
                    showMessage(
                        "warning",
                        this.$t('common.trial_expired'),
                        ' ',
                        [{name:"Take me there",func:()=>{                            
                            window.location.href="/account";
                        }}]
                    )
                }
            },
            showTrialNotification(){
                if(this.onTrial && this.subscriptionMode && this.isAfterLogin){
                    showMessage(
                        "warning",
                        this.$t('common.trial') + ' ' + this.onTrial.trialDaysLeft + ' ' + this.$t('common.days_left'),
                        ' ',
                        [{name:"Take me there",func:()=>{                            
                            window.location.href="/account";
                        }}]
                    )
                }
            },
            showPendingInvoicesNotification(){
                if(this.pendingInvoicesFlag && this.isAfterLogin){
                    showMessage(
                        "warning",
                        this.$t('common.pending_payment_notification_text'),
                        ' ',
                        [{name:"Take me there",func:()=>{                            
                            window.location.href="/account";
                        }}]
                    )
                }
                
            },
            $t(translation){
                return window.LWTranslate.get(translation);
            },
            handleAlerts(context){                
                if(context.params.error){
                    this.handleErrorAlerts(context.params.error, context.type);
                }
                if(context.params.after_purchase){
                    showMessage('inform', this.$t('starting.welcome_message_title'), this.$t('starting.welcome_message'));
                }
                if(context.params.authoring &&  params.authoring === "no_mobile"){
                    showMessage('alert', "mobile device", "Please, use a desktop or laptop computer in order to manage your school", [{"name" : "Ok"}]);
                }
                if(context.params.welcome){
                    
                     showMessage('inform', this.$t('starting.welcome_message_title'), this.$t('starting.welcome_message'));
                }
                if(context.params.product_owned){
                    showMessage('inform', this.$t('starting.product_owned_title'), this.$t('starting.product_owned_message'));
                }
                
            },
            handleErrorAlerts(error, pageType){
                const alertContent = {
                    title: 'common.oops',
                    message: error
                };
                
                switch(pageType)
                {   
                    case 'course': 
                        alertContent.title = 'course.error';
                        alertContent.message = 'course.error_msg';
                    break;
                    case 'payment':
                        alertContent.message = 'payments.payment_failed';
                    break;    

                    
                }
                if(error == 'signup_disabled'){
                    alertContent.title = 'api.register_disabled_title';
                    alertContent.message = 'api.register_disabled';
                }

                showMessage('alert', this.$t(alertContent.title), this.$t(alertContent.message),[{"name" : "Ok"}]);
            }

        },
        watch: {
            trialExpiredFlag: {
                handler(val){
                    this.showTrialExpiredNotification();
                }
            },
            pendingInvoicesFlag: {
                handler(val){
                    this.showPendingInvoicesNotification();
                }
            },
            onTrial: {
                handler(val){
                    this.showTrialNotification();
                }
            }
        },
    }
</script>

